import React, { useState } from 'react'
import { Spinner, Typography } from '@telavita-core/react-design-kit'

import { useUpdatePersonGeneral } from 'hooks'
import { RelationshipEnum } from 'models/Enums'
import { useEditFamilyContactForm } from './useEditFamilyContactForm'

import { CardWrapper } from '../CardWrapper'
import { InfoGroup } from '../InfoGroup'
import { FamilyContactInputFields } from 'components/PatientData'
import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import * as S from './styles'

export const FamilyContactSettings = (): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [showFeedback, setShowFeedback] = useState(false)

  const { formMethods, userData, hasRelativeData } = useEditFamilyContactForm()
  const { isUpdateSubmitting, onUpdatePersonGeneralData } = useUpdatePersonGeneral({
    successCallback: () => setShowFeedback(true)
  })

  if (!hasRelativeData) return null

  const familyContactData = userData.relative_data
  const familyContactInfo = [
    { label: 'Nome', value: familyContactData['relative_full_name'] },
    { label: 'Parentesco', value: RelationshipEnum[familyContactData['relationship_degree'] as keyof typeof RelationshipEnum]},
    { label: 'Telefone', value: familyContactData['relative_phone_number'] },
  ]
    
  return (
    <>
      <S.Container>
        <CardWrapper
          title='Meu contato familiar'
          subtitle='Para ajudar os profissionais de saúde em casos de emergência. Pode ser seu pai, mãe, irmã(o) ou cônjuge.'
        >
          <InfoGroup
            info={familyContactInfo}
            actionText='Modificar contato'
            actionClick={() => setIsModalOpen(true)}
          />
        </CardWrapper>
      </S.Container>
      {isModalOpen && (
        <ModalGeneric 
          modalTitle='Editar meu contato familiar'
          onCloseModal={() => setIsModalOpen(false)}
          feedbackShow={showFeedback}
          feedbackType='success'
          feedbackMessage='Seu contato de emergência foi salvo com sucesso!'
          onSuccessClose={() => setShowFeedback(false)}
        >
          <S.Form onSubmit={formMethods.handleSubmit((data) => onUpdatePersonGeneralData(data))}>
            <FamilyContactInputFields {...formMethods} />
            <Typography variant='content2' italic>
              * Preenchimento obrigatório.
            </Typography>
            <button type='submit'>
              {isUpdateSubmitting ? <Spinner /> : 'Salvar contato de emergência'}
            </button>
          </S.Form>
        </ModalGeneric>
      )}
    </>
  )
}